import { AssetAbridged } from '../abridged/asset-abridged.model';
import { SiteAbridged } from '../abridged/site-abridged.model';
import { WorkflowItem } from './workflow-item.model';

export class AssetScheduleAddWorkflowItem extends WorkflowItem {

  site: SiteAbridged;
  asset: AssetAbridged;
  worker: string;
  startTime: string;
  endTime: string;
  reason: string;
  displayOrder: number;

  public deserialize(input: any): this {
    super.deserialize(input);

    this.displayOrder = 0;
    this.site = new SiteAbridged().deserialize(input.asset.site);
    this.asset = new AssetAbridged().deserialize(input.asset);
    this.startTime = input.startTime;
    this.endTime = input.endTime;
    this.reason = input.reason;

    // rejectionReason is set by the base class from input.comments
    const startTime = new Date(input.startTime);
    const endTime = new Date(input.endTime);

    const optionsDate = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    };

    const optionsTime = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
      timeZone: 'Europe/London'
    };

    const formattedStartDate = startTime.toLocaleString('en-GB', optionsDate as Intl.DateTimeFormatOptions);
    const formattedEndDate = endTime.toLocaleString('en-GB', optionsDate as Intl.DateTimeFormatOptions);
    const formattedStartTime = startTime.toLocaleString('en-GB', optionsTime as Intl.DateTimeFormatOptions);
    const formattedEndTime = endTime.toLocaleString('en-GB', optionsTime as Intl.DateTimeFormatOptions);

    if (formattedStartDate !== formattedEndDate) {
      this.details = `${formattedStartDate}, ${formattedStartTime} - ${formattedEndDate}, ${formattedEndTime}`;
    } else {
      this.details = `${formattedStartDate}, ${formattedStartTime} - ${formattedEndTime}`;
    }

    return this;
  }

  public getTaskDetails(): string {
    return `Asset Schedule needs approval on site: ${this.site.name}, asset: ${this.asset.name}`;
  }

  public getStartDateWithoutTime(): string {
    return this.startTime.slice(0, 10);
  }
};
